function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "5. Coupe car");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_5._Coupe_car",
  "data-name": "5. Coupe car"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M36.71,29.29a1,1,0,0,0-1.42,1.42A1,1,0,0,0,36.71,29.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M11.29,29.29A1,1,0,0,0,12,31a1,1,0,0,0,1-.8A1,1,0,0,0,11.29,29.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M25,23H23a1,1,0,0,0,0,2h2A1,1,0,0,0,25,23Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M43.82,20.46l-8.38-1.4c-4.8-4.11-7.21-7.25-17.69-5.75-3.31.47-4.72.54-6.81,1.68C2.76,19.45,1.37,19.73.55,22.18-.1,24.12,0,23.64,0,27a4,4,0,0,0,4,4H7.1a5,5,0,0,0,9.8,0H31.1a5,5,0,0,0,9.8,0H44a4,4,0,0,0,4-4V25.39A5,5,0,0,0,43.82,20.46ZM23.56,15c4.27,0,6.61,2.18,8.74,4H13.87l2.29-3.44A35.4,35.4,0,0,1,23.56,15ZM2.39,23c.72,0,1-.05,1.32.31A1,1,0,0,1,3,25H2A4.2,4.2,0,0,1,2.39,23ZM12,33a3,3,0,1,1,3-3A3,3,0,0,1,12,33Zm24,0a3,3,0,1,1,3-3A3,3,0,0,1,36,33Zm8-4H40.9a5,5,0,0,0-9.8,0H16.9a5,5,0,0,0-9.8,0H4a2,2,0,0,1-2-2H3a3,3,0,0,0,.84-5.87c.11-.05,8.31-4.63,9.57-5l-1.2,1.8A2,2,0,0,0,13.87,21c25.26,0,18.82-.37,29.62,1.43A3,3,0,0,1,46,25H45a1,1,0,0,0,0,2h1A2,2,0,0,1,44,29Z"
}));

var SvgCoupeCar = function SvgCoupeCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoupeCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CoupeCar.2cf6def1.svg";
export { ForwardRef as ReactComponent };